import { useRouter } from 'next/router';
import React, { forwardRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Link from './components/Link/index.js';
import { CoreContext } from './context/index.js';

const MenuItem = forwardRef(({ item, onSelect, setShowMobileMenu }, ref) => {
    const { data: { siteConfig: { header: { shallowMobileMenu = false } = {} }, }, } = useContext(CoreContext);
    const { locale } = useRouter();
    const title = item.localized_menu_item_title || item.original_title;
    const customUrl = item.url.replace('/', '') || null;
    const { t: tCustomLink } = useTranslation('', { keyPrefix: '$local.$scandiwebCustomLinks' });
    if (!title)
        return null;
    const renderSwitch = (param) => {
        switch (param) {
            case 0:
                return (React.createElement("a", { href: `/${locale}/${tCustomLink(customUrl)}`, className: "custom-link" }, title));
            case 3:
                return (React.createElement(Link, { href: item.url, className: "link", noClass: true, onClick: () => setShowMobileMenu(false) }, title));
            default:
                return !shallowMobileMenu ? (React.createElement("button", { ref: ref, type: "button", className: "link", onClick: () => onSelect(item) },
                    title,
                    React.createElement("i", { className: "icon-right-arrow" }))) : (React.createElement(Link, { href: item.url, className: "link", noClass: true, onClick: () => setShowMobileMenu(false) },
                    React.createElement("span", null, title)));
        }
    };
    return React.createElement("li", { className: item.item_class }, renderSwitch(item.url_type));
});
MenuItem.displayName = 'MenuItem';

export { MenuItem as M };
//# sourceMappingURL=MenuItem-tjmskPE4.js.map
